<p class="error-message" *ngIf="notValid"> 
  Tout rio contient exactement 12 chiffres ou lettres (symbole + accepté).
</p>
